import React from 'react'

function HowItWorks() {
  return (
    <section className="page-content half-map sec-padding">
      <img src='assets/Images/howItWorks.svg' width='100%' alt='diagram'></img>
    </section>
  )
}

export default HowItWorks